import { FC } from 'react';
import { PartsDiagramErrorImageProps } from '../../types';

export const PartsDiagramErrorImage: FC<PartsDiagramErrorImageProps> = ({
  image,
  alt,
  classname
}) => <img alt={alt} src={image} loading="lazy" className={classname} />;
